import dayjs from 'dayjs';
import isNil from 'lodash/isNil';
import * as Yup from 'yup';
import { errorMessages } from '../../../../const/dateValidator';



export const makeValidationSchema = (collectionConfig, collection = {}) => Yup.lazy((values) => Yup.object().shape({
  use_utc_zero_time: Yup.boolean().nullable(),
  released_at: Yup.date()
    // syntax $SOMETHING (dollar sign first) means that yup should not get any params from formik values and should make a custom bool check
    .when('$collectionReleasedAt', {
      is: () => isNil(collection?.released_at),
      then: (schema) => schema.nullable(),
      otherwise: (schema) => schema.required('Released at is required'),
    })
    .before(values?.released_to, errorMessages.releasedAt.before)
    .after(collection?.released_at ? dayjs(collection.released_at) : null, 'Image released at date cannot be less than actual collection released at date'),
  ...collectionConfig?.release_range && {
    released_to: Yup.date()
      .nullable()
      .after(values?.released_at, errorMessages.releasedTo.after)
      .before(collection?.released_to ? dayjs(collection.released_to) : null, 'Image released to date cannot be more than actual collection released to date'),
  },
}));
